/* eslint-disable no-debugger */
/* eslint-disable import/no-extraneous-dependencies */
import 'jquery-ui/ui/widgets/dialog';
import 'notifyjs-browser';
import View from './View';
import '../../common/binary-ui/dropdown';
// import Elevio from '../../common/elevio';
import GTM from '../../common/gtm';
import { load } from './blockly';
import initV3 from './v3';
import { clearSearchPreserveHash, parseQueryString, isProduction, shouldEnableProductionGuards } from '../../common/utils/tools';
import { clearAutotraderSession, isAutotraderSiteLoggedIn } from '../../common/autotrader-session';
import { supabase } from '../../common/supabaseClient';
import { queryToObjectArray, AppConstants, finalizeV4OAuthWithCode, clearV4Session, redirectToV4OAuthLogin } from '../../common/appId';
import { set as setStorage, get as getStorage, removeAllTokens } from '../../common/utils/storageManager';
import { importFile } from './blockly/utils';

const showLoginOverlay = reason => {
    window.dispatchEvent(new CustomEvent('oauth.v4.showLoginOverlay', { detail: { reason: reason || 'no-session' } }));
};

if (shouldEnableProductionGuards()) {
    document.addEventListener(
        'contextmenu',
        e => {
            e.preventDefault();
        },
        false
    );
    // eslint-disable-next-line func-names
    (function() {
        // function triggerDebugger() {
        //     // This function will be repeatedly called to trigger the debugger
        //     (function anonymous() {
        //         debugger;
        //     })();
        // }
        document.onkeydown = function(e) {
            if (
                e.keyCode === 123 || // F12
                (e.ctrlKey && e.shiftKey && e.keyCode === 73) || // Ctrl+Shift+I
                (e.ctrlKey && e.shiftKey && e.keyCode === 74) || // Ctrl+Shift+J
                (e.ctrlKey && e.keyCode === 85) || // Ctrl+U
                (e.ctrlKey && e.keyCode === 83)
            ) {
                // Ctrl+S
                return false;
            }
        };

        (function() {
            const _0x1 = ['warn', 'info', 'debug'];
            for (let i = 0; i < _0x1.length; i++) {
                console[_0x1[i]] = function() {};
            }
            // Keep console.log + console.error for OAuth / auth debugging
        })();

        // Set an interval to repeatedly call the triggerDebugger function
        // setInterval(triggerDebugger, 100); // Adjust the interval as needed
    })();
}

$.ajaxSetup({
    cache: false,
});

// eslint-disable-next-line no-underscore-dangle
window._trackJs = {
    token      : process.env.TRACKJS_TOKEN,
    application: 'binary-bot',
    enabled    : isProduction(),
    console    : {
        display: false,
    },
};

// Should stay below the window._trackJs config
// require('trackjs');

const view = new View();

(async () => {
    const queryStr = parseQueryString();
    console.log(`[oauth-debug] index: hasCode=${!!queryStr.code} hasState=${!!queryStr.state} url=${window.location.href.slice(0, 80)}`);

    // Gate: check Supabase session BEFORE calling view.initPromise()
    console.log('[oauth-debug] index: calling supabase.auth.getSession...');
    const {
        data: { session },
    } = await supabase.auth.getSession();
    console.log(`[oauth-debug] index: session=${session ? `YES email=${session.user && session.user.email}` : 'NO'}`);

    const initApp = async () => {
        view.initPromise()
            .then(async () => {
                const queryStr = parseQueryString();

                if (window.location.search.slice(1, 3) === 'p=' && !getStorage('promoter')) {
                    setStorage(AppConstants.STORAGE_PROMOTER, window.location.search.split('?p=')[1]);
                    clearSearchPreserveHash();
                }

                const tokenObjectList = queryToObjectArray(queryStr);
                if (tokenObjectList.length > 0) {
                    // Legacy `?acct1=&token1=` redirects can no longer authorize under
                    // Deriv's current API. Send the user through the working v4 login.
                    clearAutotraderSession();
                    clearV4Session();
                    clearSearchPreserveHash();
                    redirectToV4OAuthLogin();
                }

                // Phones keep the block categories closed so the strategy is visible; the tab opens them.
                if (!window.matchMedia('(max-width: 769px)').matches) $('#sidebar-toggle-action').click();
                $('.show-on-load').show();
                $('.show-on-load-flex').css('display', 'flex');
                // #toolbox carries the `hidden` class (display:none !important in
                // _landing.scss), so inline display:flex alone can't override it —
                // strip the class first, then set display.
                $('#toolbox')
                    .removeClass('hidden')
                    .css('display', 'flex');
                $('.show-on-load-table').css('display', 'table');
                $('#loader').fadeOut();
                $('#hidden-blocks-message').hide();
                window.dispatchEvent(new Event('resize'));
                GTM.init();
                try {
                    initV3();
                } catch (e) {
                    console.error('[v3] skin init failed', e); // cosmetic layer: never block startup
                }

                if (window.location.search.slice(1, 3) === 's=') {
                    const strategyName = window.location.search.split('?s=')[1];
                    const importedFile = await importFile(`xml/bots/${strategyName}.xml`);
                    load(new XMLSerializer().serializeToString(importedFile));
                }
            })
            .catch(err => {
                console.error('initPromise failed:', err);
                showLoginOverlay('init-failed');
            });
    };

    if (queryStr.code) {
        const redirectParams = Object.keys(queryStr).filter(k => !['p', 's'].includes(k));
        console.log(`[oauth-debug] index: Deriv redirect detected — full search: ${window.location.search}`);
        console.log(`[oauth-debug] index: extracted params: ${redirectParams.map(k => `${k}=${k === 'code' ? `${queryStr[k].slice(0, 8)}...` : queryStr[k]}`).join(', ')}`);
        console.log(`[oauth-debug] index: code present, calling finalizeV4OAuthWithCode codeLen=${String(queryStr.code).length} state=${queryStr.state || 'none'}`);
        try {
            await finalizeV4OAuthWithCode(String(queryStr.code), queryStr.state ? String(queryStr.state) : undefined);
            console.log('[oauth-debug] index: finalizeV4OAuthWithCode SUCCESS — bearer fetched + accounts stored');
            clearSearchPreserveHash();
        } catch (e) {
            console.error('[oauth-debug] index: finalizeV4OAuthWithCode FAILED:', e && e.message, e);
            clearV4Session();
            removeAllTokens();
            clearSearchPreserveHash();
        }
    }

    if (!session) {
        if (!queryStr.code) {
            console.log('[oauth-debug] index: no session + no code — clearing v4 + tokens');
            // Normal load, no pending OAuth — treat as stale, force full re-auth
            clearV4Session();
            localStorage.removeItem('tokenList');
            localStorage.removeItem('activeToken');
        } else {
            console.log('[oauth-debug] index: no session but had code — preserving stored v4 data, waiting for login');
        }
        // Deriv redirect path: bearer + accounts already stored above, preserved for initApp
        $('#account-list, #toolbox-account-list').hide();
        showLoginOverlay('no-supabase-session');
        window.addEventListener(
            'site-login-success',
            () => {
                console.log('[oauth-debug] index: site-login-success → initApp');
                initApp();
            },
            { once: true }
        );
        return;
    }

    console.log('[oauth-debug] index: session OK → calling initApp');
    initApp();
})();
